import { LocaleUtil } from "@eres/core";
import { PrvSellLookUp, PvtSellRequest, ServiceBlock } from "./enitites";
import cfg from "./config";
import { httpGet, httpPost, httpPut } from "@eres/rest";
import { hideLoading, showLoading } from "@my-dld/utils/UIUtils";
import { getToken } from "@my-dld/utils/User";
import { isEmailAddress, normaliseMobileNumber } from "@eres/core/dist/StringUtils";

export function loadLookUp( lookUp: PrvSellLookUp ) {
	return httpGet( cfg.privateSellApi().endPoint() + "api/Lookup/Get?LookupType=" + lookUp )
	.then( checkValidationError );
}

export function validatePropertyForPrivateSell( propertyId: string, ownerPID: string, propertyTypeId: number ) {
	return httpGet( cfg.privateSellApi().endPoint() +
		`api/SaleTransaction/validate/Property?propertyId=${ propertyId }&ownerParticipantId=${ ownerPID }&propertytype=${ propertyTypeId }&transactionType=1` )
	.then( checkValidationError );
}

export function getSellRequestById( Id: string ) {
	return httpGet( cfg.privateSellApi().endPoint() + "api/SaleTransaction/sellrequest/" + Id ).then( checkValidationError );
}

export function getSellRequestByRef( refNumber: string ) {
	return httpGet( cfg.privateSellApi().endPoint() + "api/SaleTransaction/sellrequest/bookreferencenumber/" + refNumber )
	.then( checkValidationError );
}

export function generateToken( refNumber: string ) {
	return httpPost( cfg.privateSellApi().endPoint() + `api/SaleTransaction/bookingrequest/${ refNumber }/generate/otp`, undefined )
	.then( checkValidationError );
}

export function verifyTokenPS( refNumber: string, token: string, mobile: string ) {
	return httpPost( cfg.privateSellApi().endPoint() + `api/SaleTransaction/bookingrequest/${ refNumber }/verify/${ mobile }/otp/${ token }`, undefined )
	.then( checkValidationError );
}

export function mySellRequests( participantId: string, pageSize: number, pageNumber: number, filter: string ) {
	return httpGet( cfg.privateSellApi().endPoint() +
		`api/SaleTransaction/bookingrequest/seller/${ participantId }/listing/status/${ filter }?pageSize=${ pageSize }&pageNumber=${ pageNumber }` )
	.then( checkValidationError );
}

export function getDocument( businessId: string ) {
	return httpGet( cfg.privateSellApi().endPoint() + "api/SaleTransaction/Get/Document/" + businessId )
	.then( checkValidationError );
}

export function acceptBookingRequest( data: PvtSellRequest ) {
	return httpPut( cfg.privateSellApi().endPoint() + "api/SaleTransaction/bookrequest/accept", data ).then( checkValidationError );
}

export function validatePersonByEmiratesId( emiratesID: string, dob: string ) {
	return httpGet( cfg.privateSellApi().endPoint() + "api/SaleTransaction/participant/emiratesId/" + emiratesID + "?dateOfBirth=" + dob )
	.then( checkValidationError )
	.then( x => {
		let em = x?.email;
		if ( x && !isEmailAddress( em ) ) {
			x.email = "";
		}
		let mob = x?.mobile;
		if ( mob ) {
			mob = normaliseMobileNumber( mob );
		}
		if ( x && ( mob.length < 8 ) ) {
			x.mobile = "";
		}
		return x;
	} );
}

export function getInvoiceBy( referenceId: string, type: number ) {
	return httpGet( cfg.privateSellApi().endPoint() + "api/SaleTransaction/bookingrequest/" + referenceId + "/payment/invoice/" + type )
	.then( checkValidationError );
}

export function cancelRequest( requestID: string ) {
	return httpPut( cfg.privateSellApi().endPoint() + `api/SaleTransaction/sellrequest/${ requestID }/cancel` )
	.then( checkValidationError );
}

export function verifyOtpByMobile( mobile: string ) {
	return httpGet( cfg.identityOTPApi().endPoint() + "OTP/SMS/REST/" + mobile )
	.then( checkValidationError );
}

export function verifyOtpByEmail( email: string ) {
	return httpGet( cfg.identityOTPApi().endPoint() + "OTP/" + email + "/REST/" )
	.then( checkValidationError );
}

export function verifyToken( token: string, value: string ) {
	return httpGet( cfg.identityOTPApi().endPoint() + "OTP/Verify/" + value + "/" + token + "/REST" )
	.then( checkValidationError );
}

export function createSellRequest( data: PvtSellRequest ) {
	return httpPost( cfg.privateSellApi().endPoint() + "api/SaleTransaction/sellrequest", data ).then( checkValidationError );
}

export function updateSellRequest( data: PvtSellRequest ) {
	return httpPut( cfg.privateSellApi().endPoint() + "api/SaleTransaction/sellrequest", data ).then( checkValidationError );
}

export function rejectBookingRequest( data: PvtSellRequest ) {
	return httpPut( cfg.privateSellApi().endPoint() + "api/SaleTransaction/bookrequest/review", data ).then( checkValidationError );
}

export function uploadDoc( content: string, docType: string, ext: string ) {
	return httpPost( cfg.privateSellApi().endPoint() + "api/FileUpload/FileUpload", {
		fileContent: content,
		documentType: docType,
		fileExtension: ext,
	} );
}

export function getPSTCUrl() {
	return cfg.privateSellApi().psTCUrl();
}

export function setOTP() {
	return cfg.privateSellApi().setOTP();
}

export function getNumberOfPage() {
	return cfg.privateSellApi().maxPagesPerDoc();
}

export function getMaxPageSize() {
	return cfg.privateSellApi().maxDocSize();
}

export function getMaxPropertyImageCount() {
	return cfg.privateSellApi().maxPropertyImages();
}

function checkValidationError( response: any, key: string = "validationErrorsList" ): Promise<any> {
	if ( response ) {
		if ( response.hasOwnProperty( key ) ) {
			let errors = response[ key ];
			if ( errors !== undefined && Array.isArray( errors ) && errors.length > 0 ) {
				let message = errors.map( e => e.errorMessageSet ? LocaleUtil.getLocalValue( e.errorMessageSet ) : e.errorMessage ).join( "\n" ).trim();
				return Promise.reject( {
					type: "ValidationError",
					response: response && response.response ? response.response : undefined,
					errors: errors,
					message: message,
				} );
			}
		}
	}
	if ( response.response ) return response.response;
	return response;
}


export function checkResponseError( response: any ) {
	let errors = response.errors;
	let block: ServiceBlock = { isValid: true, errors: [] };
	if ( errors && Array.isArray( errors ) && errors.length > 0 ) {
		let errors = response.errors;
		for ( let i = 0; i < errors.length; i++ ) {
			let error = errors[ i ];
			let type = error.validationType;
			if ( type === 2 || type === 3 ) {
				block.isValid = false;
				block.errors.push( { isWarning: true, ...error.errorMessageSet } );
			} else {
				block.errors.push( { isWarning: false, ...error.errorMessageSet } );
			}
		}
	}
	return block;
}

export function showTerms() {
	showLoading();
	let params = {
		token: getToken() ?? "",
	};

	fetch( getPSTCUrl(), { headers: params } ).then( r => r.blob() )
	.then( blob => {
		let newBlob = new Blob( [ blob ], { type: "application/pdf" } );
		let url = window.URL.createObjectURL( newBlob );
		let a = document.createElement( "a" );
		a.href = url;
		a.download = "private_sell_terms_conditions.pdf";
		a.click();
		hideLoading();
	} ).catch( e => hideLoading() );
}
